'use client'
import {
  CollapsableText_default
} from "./chunk-MAJWJHOB.mjs";
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulButton_default
} from "./chunk-K3ITZBKW.mjs";
import {
  ContentfulImage_default,
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/cta/Cta.tsx
import { Button, Paper, Typography } from "@wbk/ui";
import { Link } from "@wbk/config";
import { jsx, jsxs } from "react/jsx-runtime";
var Cta = ({ section }) => {
  var _a, _b;
  const card = (_a = section.contentCollection.items) == null ? void 0 : _a[0];
  const links = (_b = section.webLinksCollection) == null ? void 0 : _b.items;
  if (!card) {
    return null;
  }
  return /* @__PURE__ */ jsx(DecoratedSection_default, { section, className: "container", children: /* @__PURE__ */ jsxs(
    Paper,
    {
      size: "L",
      className: "gap-L flex flex-col justify-between overflow-hidden lg:flex-row lg:items-stretch",
      style: {
        backgroundColor: card.color
      },
      children: [
        /* @__PURE__ */ jsxs("div", { className: "gap-L flex flex-col justify-between", children: [
          /* @__PURE__ */ jsxs("div", { className: "space-y-S", children: [
            card.image11 && /* @__PURE__ */ jsx(ContentfulMedia_default, { className: "mb-L h-auto w-20", media: card.image11 }),
            /* @__PURE__ */ jsx(Typography, { variant: "heading-M", children: card.title }),
            card.description ? /* @__PURE__ */ jsx(CollapsableText_default, { text: card.description, minimum: 5 }) : null,
            (links == null ? void 0 : links.length) ? /* @__PURE__ */ jsx("div", { className: "gap-L py-XS grid w-full grid-cols-1 sm:grid-cols-2", children: links.map((link, index) => /* @__PURE__ */ jsxs("div", { className: "gap-S flex items-center", children: [
              /* @__PURE__ */ jsx("div", { className: "border-text-tertiary flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2", children: /* @__PURE__ */ jsx(Typography, { variant: "label-M", children: index + 1 }) }),
              /* @__PURE__ */ jsx(Typography, { children: link.label })
            ] }, link.id)) }) : null
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-start gap-4 lg:flex-row lg:items-center lg:gap-6", children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                as: Link,
                href: card.href,
                "aria-label": card.title ? `${card.buttonLabel} - ${card.title}` : void 0,
                children: card.buttonLabel
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
              card.subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body-XS", color: "text-secondary", children: card.subtitle }),
              card.icon && /* @__PURE__ */ jsx(ContentfulMedia_default, { media: card.icon })
            ] })
          ] })
        ] }),
        card.image31 && /* @__PURE__ */ jsx(ContentfulMedia_default, { media: card.image31, className: "-mb-6 self-end ltr:-mr-6 rtl:-ml-6" })
      ]
    }
  ) });
};
var Cta_default = Cta;

// src/components/cta/CtaBanner.tsx
import { Paper as Paper2, Typography as Typography2 } from "@wbk/ui";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var CtaBanner = ({ section }) => {
  var _a, _b;
  const card = (_a = section.contentCollection.items) == null ? void 0 : _a[0];
  if (!card) {
    return null;
  }
  return /* @__PURE__ */ jsx2(DecoratedSection_default, { section, className: "container", children: /* @__PURE__ */ jsxs2(
    Paper2,
    {
      size: "L",
      border: true,
      className: "gap-L relative flex flex-col items-start overflow-hidden bg-cover bg-no-repeat lg:flex-row lg:items-center lg:justify-between",
      style: {
        backgroundImage: ((_b = card.background) == null ? void 0 : _b.url) ? `url(${card.background.url})` : void 0
      },
      children: [
        /* @__PURE__ */ jsxs2("div", { className: "gap-M flex flex-col items-center lg:flex-row", children: [
          card.image && /* @__PURE__ */ jsx2("div", { className: "relative shrink-0", children: /* @__PURE__ */ jsx2(ContentfulMedia_default, { media: card.image }) }),
          /* @__PURE__ */ jsxs2("div", { className: "space-y-2 text-center lg:text-start", children: [
            card.title && /* @__PURE__ */ jsx2(Typography2, { as: "h2", variant: "heading-XXL", children: card.title }),
            card.subtitle && /* @__PURE__ */ jsx2(Typography2, { variant: "body-L", color: "text-secondary", children: card.subtitle })
          ] })
        ] }),
        /* @__PURE__ */ jsx2("div", { className: "flex w-full flex-wrap items-center justify-center gap-2 lg:w-fit", children: section.webLinksCollection.items.map((link) => /* @__PURE__ */ jsx2(ContentfulButton_default, { link, phill: true, className: "w-full lg:w-fit" }, link.id)) })
      ]
    }
  ) });
};
var CtaBanner_default = CtaBanner;

// src/components/poll/PollSection.tsx
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Link as Link2, useRouter, useTranslation } from "@wbk/config";
import { Button as Button2, RadioGroup, ToggleGroup, Typography as Typography3 } from "@wbk/ui";
import { useAuth } from "@wbk/auth";
import { AnimatedCheck, CheckIcon } from "@wbk/svg";
import { Fragment, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var PollSection = ({ section }) => {
  var _a, _b, _f, _g;
  const poll = (_b = (_a = section == null ? void 0 : section.contentCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0];
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { user } = useAuth({ autoFetch: true });
  const { locale, pathname } = useRouter();
  const { t } = useTranslation("common");
  const {
    register,
    control,
    formState: { errors },
    handleSubmit
  } = useForm();
  const noOptionsAvailable = !poll.isTextInput && !poll.optionsCollection.items.length;
  if (!poll || noOptionsAvailable) {
    return null;
  }
  const onSubmit = (data) => __async(null, null, function* () {
    try {
      setIsLoading(true);
      yield fetch(poll.formBucketUrl, {
        method: "POST",
        headers: {
          accept: "application/javascript",
          "content-type": "application/json"
        },
        body: JSON.stringify({
          user_id: user == null ? void 0 : user._id,
          user_email: user == null ? void 0 : user.email,
          user_first_name: user == null ? void 0 : user.first_name,
          user_last_name: user == null ? void 0 : user.last_name,
          user_country: user == null ? void 0 : user.cell_country_code,
          user_cell_number: user == null ? void 0 : user.cell_number,
          type: "quiz",
          date: (/* @__PURE__ */ new Date()).toISOString(),
          question: poll.title,
          answer: data.answer
        })
      });
      setIsSuccess(true);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  });
  return /* @__PURE__ */ jsx3(
    DecoratedSection_default,
    {
      section,
      "data-testid": `pollSection_${section.id}`,
      className: "container bg-cover",
      children: /* @__PURE__ */ jsxs3("div", { className: "overflow-hidden rounded-2xl px-4 py-8 md:px-8", children: [
        /* @__PURE__ */ jsxs3("div", { className: "mx-auto max-w-2xl text-center", children: [
          /* @__PURE__ */ jsx3(Typography3, { as: "h2", variant: "heading-L", children: poll.title || section.title }),
          poll.subtitle && /* @__PURE__ */ jsx3(Typography3, { children: poll.subtitle })
        ] }),
        /* @__PURE__ */ jsx3(
          "form",
          {
            "data-multi": poll.isMultiOption,
            className: "mx-auto w-full max-w-lg space-y-2 rounded-xl bg-cover p-4 data-[multi=true]:max-w-full",
            onSubmit: handleSubmit(onSubmit),
            children: isSuccess ? /* @__PURE__ */ jsxs3("div", { className: "text-center", children: [
              /* @__PURE__ */ jsx3(AnimatedCheck, { className: "text-success mx-auto h-32 w-32" }),
              /* @__PURE__ */ jsxs3("p", { className: "text-lg", children: [
                " ",
                t("common:answer_submitted"),
                " "
              ] })
            ] }) : /* @__PURE__ */ jsxs3(Fragment, { children: [
              /* @__PURE__ */ jsx3("fieldset", { children: poll.isTextInput ? /* @__PURE__ */ jsx3(
                "textarea",
                __spreadValues({
                  id: "message",
                  className: "border-paper bg-body-dark/20 hover:bg-body-dark/30 focus:border-paper focus:bg-body-dark/20 max-h-[120px] min-h-[80px] w-full appearance-none rounded-lg border p-2",
                  placeholder: t("common:write_answer")
                }, register("answer", {
                  required: t("common:validation.required"),
                  minLength: {
                    value: 20,
                    message: t("common:validation.min_length", { min: 20 })
                  }
                }))
              ) : /* @__PURE__ */ jsx3(
                Controller,
                {
                  name: "answer",
                  control,
                  rules: { required: t("common:validation.required") },
                  render: (_c) => {
                    var { field: _d } = _c, _e = _d, { value } = _e, props = __objRest(_e, ["value"]);
                    if (poll.isMultiOption) {
                      return /* @__PURE__ */ jsx3(
                        ToggleGroup,
                        __spreadProps(__spreadValues({}, props), {
                          label: "",
                          groupClassName: "justify-center grid grid-cols-2 xs:flex",
                          className: "xs:basis-40 grow-0 border-2 border-transparent bg-[#242427] data-[state=on]:border-blue-500 data-[state=on]:bg-[#242427]",
                          type: "multiple",
                          value,
                          options: poll.optionsCollection.items.map((option) => {
                            var _a2;
                            const isSelected = value == null ? void 0 : value.includes(option.slug);
                            return {
                              text: /* @__PURE__ */ jsxs3(Fragment, { children: [
                                isSelected && /* @__PURE__ */ jsx3(CheckIcon, { className: "absolute top-0 m-1 h-5 w-5 text-blue-500 ltr:right-0 rtl:left-0" }),
                                ((_a2 = option.icon) == null ? void 0 : _a2.url) && /* @__PURE__ */ jsx3(
                                  ContentfulImage_default,
                                  {
                                    className: "mx-auto pb-1",
                                    src: option.icon.url,
                                    alt: option.icon.title,
                                    width: 25,
                                    height: 25
                                  }
                                ),
                                option.title
                              ] }),
                              value: option.slug
                            };
                          })
                        })
                      );
                    }
                    return /* @__PURE__ */ jsx3(
                      RadioGroup,
                      __spreadProps(__spreadValues({}, props), {
                        label: "",
                        className: "bg-[#242427]",
                        options: poll.optionsCollection.items.map((option) => {
                          var _a2;
                          return {
                            text: /* @__PURE__ */ jsxs3("p", { className: "flex items-center gap-2", children: [
                              ((_a2 = option.icon) == null ? void 0 : _a2.url) && /* @__PURE__ */ jsx3(
                                ContentfulImage_default,
                                {
                                  className: "",
                                  src: option.icon.url,
                                  alt: option.icon.title,
                                  width: 20,
                                  height: 20
                                }
                              ),
                              option.title
                            ] }),
                            value: option.slug
                          };
                        }),
                        value: value || ""
                      })
                    );
                  }
                }
              ) }),
              ((_f = errors == null ? void 0 : errors.answer) == null ? void 0 : _f.message) && /* @__PURE__ */ jsx3("div", { className: "text-error my-1 min-h-[16px] text-xs", children: /* @__PURE__ */ jsx3("p", { children: (_g = errors == null ? void 0 : errors.answer) == null ? void 0 : _g.message }) }),
              /* @__PURE__ */ jsx3("div", { className: "mx-auto max-w-lg pt-4", children: user ? /* @__PURE__ */ jsx3(Button2, { type: "submit", className: "w-full", loading: isLoading, children: t("common:submit") }) : /* @__PURE__ */ jsx3(
                Button2,
                {
                  type: "button",
                  as: Link2,
                  to: `/${locale}/login?redirect=${pathname}`,
                  theme: "secondary",
                  className: "w-full",
                  children: t("common:login_to_submit")
                }
              ) })
            ] })
          }
        )
      ] })
    }
  );
};
var PollSection_default = PollSection;

// src/components/resell/ResellBanner.tsx
import { Typography as Typography4 } from "@wbk/ui";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var ResellBanner = ({ section }) => {
  var _a, _b, _c;
  const card = (_a = section.contentCollection.items) == null ? void 0 : _a[0];
  if (!card) {
    return null;
  }
  return /* @__PURE__ */ jsx4(DecoratedSection_default, { section, className: "container", children: /* @__PURE__ */ jsxs4("div", { className: "py-L flex flex-col justify-between overflow-hidden lg:flex-row lg:items-center lg:py-0", children: [
    /* @__PURE__ */ jsxs4("div", { className: "space-y-6", children: [
      /* @__PURE__ */ jsx4(ContentfulMedia_default, { className: "max-w-20", media: card.image }),
      /* @__PURE__ */ jsxs4("div", { className: "space-y-4", children: [
        /* @__PURE__ */ jsx4(Typography4, { variant: "heading-M", children: card.title }),
        card.description && /* @__PURE__ */ jsx4(Typography4, { children: card.description })
      ] }),
      /* @__PURE__ */ jsxs4("div", { className: "space-y-L", children: [
        !!((_c = (_b = section.webLinksCollection) == null ? void 0 : _b.items) == null ? void 0 : _c.length) && /* @__PURE__ */ jsx4("div", { className: "mt-6 flex flex-wrap gap-4", children: section.webLinksCollection.items.map((link) => /* @__PURE__ */ jsx4(ContentfulButton_default, { link }, link.id)) }),
        /* @__PURE__ */ jsxs4("div", { className: "gap-XXS flex items-center", children: [
          card.icon && /* @__PURE__ */ jsx4(ContentfulMedia_default, { className: "h-6 w-6 shrink-0", media: card.icon }),
          card.subtitle && /* @__PURE__ */ jsx4(Typography4, { variant: "body-S", children: card.subtitle })
        ] })
      ] })
    ] }),
    card.image31 && /* @__PURE__ */ jsx4(
      ContentfulMedia_default,
      {
        media: card.image31,
        className: "hidden self-end lg:block ltr:-mr-6 rtl:-ml-6"
      }
    )
  ] }) });
};
var ResellBanner_default = ResellBanner;

export {
  Cta_default,
  CtaBanner_default,
  PollSection_default,
  ResellBanner_default
};
//# sourceMappingURL=chunk-B7OACJOC.mjs.map